 new BeerSlider(document.getElementById('slider'));
$(function(){
   new BeerSlider(document.getElementById('slider'));
		// function sizeiframe () {
		// 	document.getElementById("Video_Adaptive").style.height=document.getElementById("Video_Adaptive").scrollWidth/16*9+"px";
		// }
		// sizeiframe ();
		// window.onresize = function(){
		// 	sizeiframe ();
		// }
		$("#slider").mousedown(function(){
			$(this).addClass("mouse_active");
		}).mouseup(function(){
			$(this).removeClass("mouse_active");
		})
	})